import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import ErrorBoundary from 'components/ErrorBoundary';
import ElementInView from 'components_v2/common/ElementInView';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import Cookie from 'utils/cookies';
// import StickyDiv from 'components/StickyDiv';
import s from './Sidebar.scss';
import { LIVE_SCORE_CARD_API } from '../../../constants';
import Ctawithimage from '../CTA_with_image/Ctawithimage';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import ToiPlusPlanPageCta from '../../common/ToiPlusPlanPageCta/ToiPlusPlanPageCta';

class Sidebar extends React.Component {
  constructor() {
    super();
    this.state = {
      hasMounted: false,
      loadingStatus: 'LOADING',
    };
  }

  componentDidMount() {
    this.setState({
      hasMounted: true,
    });
  }

  getLoadingStatus = status => {
    this.setState({
      loadingStatus: status,
    });
  };

  getSpotlightAllowedAds = adname => {
    if (this.props.spotlightSpecificAds && this.props.isAdRemoved) {
      const names = ['mrec'];
      if (names.includes(adname)) {
        return true;
      }
    }
    return !this.props.isAdRemoved;
  };

  getWidgetsMap(sidebarArr) {
    const {
      data,
      breadCrumbString,
      params = {},
      msid,
      gaPrefix,
      sidebarMapping,
      ads,
      widgetCss,
      morlinkOpenInNewTab,
      gaAction,
      AffiliateRHSWidget,
      //AstroTalkRHSWidget,
      OpenMindAstroRHSWidget,
      isStickyHeaderVisible,
      stickySideBarClasses,
      ...props
    } = this.props;
    let stickyBehaviorClass;
    if (stickySideBarClasses) {
      stickyBehaviorClass = classNames({
        [`${stickySideBarClasses.sticky}`]: isStickyHeaderVisible,
        [`${stickySideBarClasses.stickyWithoutHeader}`]: !isStickyHeaderVisible,
      });
    }
    if (sidebarArr && sidebarArr.map) {
      return sidebarArr.map((item, index) => {
        const key = `${item.id || item.divId || item.slotId || index}${
          msid ? `-${msid}` : ''
        }`;
        const isAdvertisement = item.tn === 'ad';
        const isAffiliatesRHSWidget = item.tn === 'affiliates_widget_rhs';
        //const isAstroTalkRHSWidget = item.tn === 'AstroTalkRHSWidget';
        const isOpenMindAstroRHSWidget = item.tn === 'OpenMindAstroRHSWidget';
        const isImageBannerRHSWidget = item.tn === 'cta_with_image';
        const MyComp = sidebarMapping[item.tn];

        if (item.items) {
          // eslint-disable-next-line no-param-reassign
          item.data = item.items;
        }

        let itemData = Array.isArray(item.data)
          ? [...item.data]
          : { ...item.data };

        // For lazy loading ET Iframe
        let useIframeIntersectionObserver = false;
        if (
          item.tn === 'iframe' &&
          itemData &&
          itemData.id &&
          (itemData.id === 'etiframe' || itemData.id === 'creditscoreiframe')
        ) {
          useIframeIntersectionObserver = true;
        }

        let reqClassName = `${s.widget}  ${widgetCss}`;
        if (isAffiliatesRHSWidget && AffiliateRHSWidget) {
          return (
            <React.Fragment key={`${item.tn}_${index}`}>
              {AffiliateRHSWidget}
            </React.Fragment>
          );
        }
        // if (isAstroTalkRHSWidget && AstroTalkRHSWidget) {
        //   return (
        //     <React.Fragment key={`${item.tn}_${index}`}>
        //       {AstroTalkRHSWidget}
        //     </React.Fragment>
        //   );
        // }
        if (isOpenMindAstroRHSWidget && OpenMindAstroRHSWidget) {
          return (
            <React.Fragment key={`${item.tn}_${index}`}>
              {OpenMindAstroRHSWidget}
            </React.Fragment>
          );
        }
        if (isImageBannerRHSWidget && !this.props.isFeatureshow) {
          return (
            <div className="imageBanner">
              <InViewObserver
                inViewCallback={() => {
                  if (item && item.id === 'etmoney') {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      type: 'et_money_banner',
                      category: 'as_rhs',
                    });
                  }
                }}
              >
                <Ctawithimage
                  key={item.tn}
                  data={item}
                  gaAction={`${item.name}_Click`}
                  gaLabelPerfix={`${item.name}/click/`}
                />
              </InViewObserver>
            </div>
          );
        }
        if (isAdvertisement) {
          let adObj = item;
          if (item.adType === 'dfp') {
            if (item.isjarvis) {
              itemData = {
                ...adObj,
                articleIndex: this.props.articleIndex,
              };
              props.msid = msid;
            } else {
              if (ads && item.adName) {
                adObj = {
                  ...adObj,
                  ..._get(ads, `dfp.slots.${item.adName}`, {}),
                };
              }
              reqClassName = `${s.widget}  ${widgetCss}`;
              const divid = `${adObj.divId || adObj.id}${
                msid ? `-${msid}` : ''
              }`;
              itemData = {
                name: adObj.name || 'mrec',
                size: adObj.size,
                adCode: adObj.adCode,
                adType: adObj.adType,
                divId: divid,
                msid,
                articleIndex: this.props.articleIndex,
              };
            }
          } else if (item.adType === 'ctn') {
            if (ads && item.adName) {
              adObj = {
                ...adObj,
                ..._get(ads, `ctn.slots.${item.adName}`, {}),
              };
            }
            reqClassName = s.widget;
            itemData = {
              name: adObj.name || 'mrec',
              adCode: adObj.slotId,
              msid,
              isCTN: true,
            };
          }
          if (itemData?.name) {
            props.inPlaceholder = 'adplaceholder';
            props.adWapperClass = `${s.dfpslot} paisa-wrapper`;
            itemData.skipReRender = 1;
          }
        }

        if (MyComp) {
          //@todo: refactor code with feed engine feed
          // const { currentCountry, secName } = this.props;
          const { currentCountry } = this.props;
          if (
            item &&
            item.geo &&
            typeof item.geo === 'string' &&
            item.tn !== 'TOIPlusWidget'
          ) {
            const geoArr = item.geo.split('|');
            if (
              !currentCountry ||
              geoArr.indexOf(this.props.currentCountry) === -1
            ) {
              return null;
            }
          }
          // if (
          //   item &&
          //   item.tn === 'ad' &&
          //   typeof item.rhsPos !== 'undefined' &&
          //   item.rhsPos === 5 &&
          //   secName &&
          //   (secName.toLowerCase() === 'world' ||
          //     secName.toLowerCase() === 'city')
          // ) {
          //   if (
          //     !currentCountry ||
          //     (currentCountry && currentCountry.toLowerCase() === 'in')
          //   ) {
          //     return null;
          //   }
          // }
          if (item && item.tn === 'calculator') {
            return (
              <MyComp
                key={`${item.tn}_${index}`}
                items={item.items}
                {...item}
                isWapView={false}
                isArticleshowPage
              />
            );
          }
          if (
            item &&
            item.tn === 'scorecardwidget' &&
            !this.props.isEtimes &&
            !this.props.isMspArticle
          ) {
            return (
              <ErrorBoundary key={`${item.tn}_${index}`}>
                <MyComp
                  loadInView
                  loadableComponentName="IPLWidget"
                  dataUrl={LIVE_SCORE_CARD_API}
                  msid={this.props.msid}
                  isLiveScoreWidget
                  autoRefresh
                  isLiveIccIplWpl
                  gaData="Scorecard_widget|click_web|Articleshow"
                  gaViewData={['Scorecard_widget', 'view_web', 'Articleshow']}
                />
              </ErrorBoundary>
            );
          }

          if (
            item &&
            item.tn === 'TOIPlusWidget' &&
            (Cookie.get('ssoid') || Cookie.get('ssoId'))
          ) {
            return (
              <MyComp
                item={item}
                isPrime={this.props.isUserPrime}
                isLiveBlog={window.location.href.indexOf('/liveblog') > -1}
                isArticleShow={
                  window.location.href.indexOf('/articleshow') > -1
                }
                msid={msid}
              />
            );
          }

          // if (index === data.length - 1) {
          //   return (
          //     <StickyDiv
          //       key={item.id || index}
          //       stickyClass={this.props.applyStickyClass ? s.sticky : ''}
          //       //outerContainerClass={s.tabNavWrapper}
          //       offsetFromTop={10}
          //     >
          //       <MyComp
          //         key={index}
          //         data={itemData}
          //         type={item.type}
          //         className={reqClassName}
          //         offsetVertical={800}
          //         lazyload={params.lazyloadRhsAds}
          //         styleObj={s}
          //         isCTN={itemData.isCTN}
          //       />
          //     </StickyDiv>
          //   );
          // }
          const fireInViewGA = item.tn === 'list';
          let inViewGaLabel = item.id;
          if (item.id === 'spotlight_articles') {
            itemData.map(ele => {
              if (ele.id) {
                inViewGaLabel = `${inViewGaLabel}_${ele.id}`;
              }
              return inViewGaLabel;
            });
            inViewGaLabel = `${inViewGaLabel}_asrhs`;
          }
          const Comp = (
            <MyComp
              morlinkOpenInNewTab={morlinkOpenInNewTab}
              key={`${item.tn}_${index}`}
              view={item.view || ''}
              name={item.name || item.title}
              theme={item.theme}
              type={item.type}
              item={item}
              liveblogData={item.tn === 'lbgwidget' ? item : {}}
              data={itemData}
              src={item.src}
              url={item.wu || item.dataurl || item.url}
              classvalue="asAffiliate"
              primeBannerId={item.primebannerid}
              currentCountry={this.props.currentCountry}
              className={reqClassName}
              styleObj={s}
              offsetVertical={800}
              lazyload={
                (params.lazyloadRhsAds && index > 5) ||
                parseInt(item.checkCampaign, 10) === 1
              }
              isCTN={itemData.isCTN}
              // inlineGptAd={!this.props.perpetual && index === 0}
              openVideosInTheatre={
                item.type === 'multipleListSection'
                  ? this.props.openVideosInTheatre
                  : null
              }
              gaAction={
                (item.type === 'multipleListSection' ||
                  this.props.gaCategory) &&
                this.props.gaAction
                  ? this.props.gaAction
                  : ''
              }
              gaPrefix={gaPrefix}
              hideImage={item.showimage === '0'}
              isRHSWidgetAS={this.props.isRHSWidgetAS}
              isRHSWidgetPS={this.props.isRHSWidgetPS}
              getLoadingStatus={this.getLoadingStatus}
              useIframeIntersectionObserver={useIframeIntersectionObserver}
              isNavigationAbsent={item && item.name === 'etimes_video_widget'}
              {...props}
              // openVideoTheatre={
              //   item.type === 'multipleListSection'
              //     ? this.props.openVideoTheatre
              //     : null
              // }
              // callback={
              //   isAdvertisement && itemData.refresh && !this.props.perpetual
              //     ? attachAfterTimeout
              //     : undefined
              // }
            />
          );
          if (
            data?.onlyAdSticky &&
            item &&
            item.tn === 'ad' &&
            !this.props.isAdRemoved &&
            !this.props.isUserPrime
          ) {
            return (
              <div
                key={`${item.tn}_${index}`}
                data-translate-sticky="90"
                className={`${this.props.stickyCss} ${stickyBehaviorClass} ${
                  s.stickyWrapper
                } stickymrecad`}
              >
                <React.Fragment key={`${item.tn}_${index}`}>
                  {Comp}
                  {item.showRemoveAdButton && (
                    <ToiPlusPlanPageCta
                      msid={msid}
                      pageType={
                        this.props.isRHSWidgetAS ? 'articleshow' : 'liveblog'
                      }
                      AdSlotnum={0}
                      adname={item.name}
                    />
                  )}
                </React.Fragment>
              </div>
            );
          }
          if (
            item &&
            item.tn === 'ad' &&
            !this.props.isUserPrime &&
            this.getSpotlightAllowedAds(item.name)
          ) {
            return (
              <React.Fragment key={`${item.tn}_${index}`}>
                {Comp}
                {item.showRemoveAdButton && (
                  <ToiPlusPlanPageCta
                    msid={msid}
                    pageType={
                      this.props.isRHSWidgetAS ? 'articleshow' : 'liveblog'
                    }
                    AdSlotnum={0}
                    adname={item.name}
                  />
                )}
              </React.Fragment>
            );
          }
          if (
            item &&
            item.tn === 'TOIPlusWidget' &&
            (Cookie.get('ssoid') || Cookie.get('ssoId'))
          ) {
            return (
              <div className={`${s.toipluswidget}`} key={`${item.tn}_${index}`}>
                {(!this.state.hasMounted ||
                  this.state.loadingStatus === 'LOADING') && (
                  <LoaderSpinner
                    overwriteWrapper={s.spinnerwrapper}
                    overwriteLoader={s.spinner}
                  />
                )}
                {this.state.hasMounted && Comp}
              </div>
            );
          }
          return (
            <ErrorBoundary key={`${item.tn}_${index}`}>
              {fireInViewGA ? (
                <ElementInView key={key} gaLabel={`${inViewGaLabel}_view`}>
                  {Comp}
                </ElementInView>
              ) : (
                <React.Fragment key={key}>{Comp}</React.Fragment>
              )}
            </ErrorBoundary>
          );
        }
        return null;
      });
    }

    return null;
  }

  makeAllAdSticky = sidebarArr => {
    const stickyContainer = [];
    let adCount = -1;
    sidebarArr.forEach(item => {
      if (item.tn === 'ad') {
        adCount += 1;
        stickyContainer.push([]);
      }
      if (stickyContainer[adCount]) {
        stickyContainer[adCount].push(item);
      }
    });

    if (stickyContainer.length) {
      return stickyContainer.map(items => (
        <div>{this.getWidgetsMap(items)}</div>
      ));
    }
    return null;
  };
  getAllWidgets() {
    const { data, onlyAdSticky } = this.props.data;
    const showToiPlusWidget = this.props.showToiPlusEntryPoints;
    const { rhsWidgetPriority, isMspArticle, isSaleLive } = this.props;
    const sidebarArr = [];
    let affiliateWidget;
    if (data instanceof Array) {
      for (let i = 0; i < data.length; i += 1) {
        // enable this code to move affiliate widget after first ad
        if (isSaleLive && data[i].tn === 'affiliates_widget_rhs') {
          affiliateWidget = data[i];
          // eslint-disable-next-line no-continue
          continue;
        }
        if (
          !rhsWidgetPriority ||
          isMspArticle ||
          (data[i].tn === 'ad' && this.getSpotlightAllowedAds(data[i].name)) ||
          data[i].tn === 'cta_with_image' ||
          (rhsWidgetPriority &&
            ((data[i].tn &&
              rhsWidgetPriority[data[i].tn] &&
              rhsWidgetPriority[data[i].tn] === '1') ||
              (data[i].id &&
                rhsWidgetPriority[data[i].id] &&
                rhsWidgetPriority[data[i].id] === '1')))
        ) {
          if (!data[i].sticky) {
            if (data[i].tn === 'TOIPlusWidget') {
              if (
                showToiPlusWidget &&
                (Cookie.get('ssoid') || Cookie.get('ssoId'))
              ) {
                sidebarArr.push(data[i]);
              }
            } else {
              sidebarArr.push(data[i]);
            }
          }
        }
      }
      // enable this code to move affiliate widget after first ad
      if (isSaleLive && affiliateWidget) {
        let affWidgetPosition = 0;
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < sidebarArr.length; index++) {
          if (affWidgetPosition === 0 && sidebarArr[index].tn === 'ad') {
            affWidgetPosition = index + 1;
          }
        }
        sidebarArr.splice(affWidgetPosition, 0, affiliateWidget);
      }
      //  ad sticky is on
      if (onlyAdSticky && !this.props.isUserPrime) {
        return this.makeAllAdSticky(sidebarArr);
      }

      return this.getWidgetsMap(sidebarArr);
    }
    return null;
  }
  getStickyWidgets() {
    const { data } = this.props.data;
    const showToiPlusWidget = this.props.showToiPlusEntryPoints;
    const {
      rhsWidgetPriority,
      isMspArticle,
      isAdRemoved,
      isSaleLive,
    } = this.props;
    let stickyArr = [];
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i += 1) {
        if (
          !rhsWidgetPriority ||
          isMspArticle ||
          (!isAdRemoved && data[i].tn === 'ad') ||
          (rhsWidgetPriority &&
            ((data[i].tn &&
              rhsWidgetPriority[data[i].tn] &&
              rhsWidgetPriority[data[i].tn] === '1') ||
              (data[i].id &&
                rhsWidgetPriority[data[i].id] &&
                rhsWidgetPriority[data[i].id] === '1')))
        ) {
          if (data[i].sticky) {
            if (
              !(data[i].tn === 'TOIPlusWidget' && !showToiPlusWidget) &&
              !(isSaleLive && data[i].tn === 'affiliates_widget_rhs')
            ) {
              stickyArr.push(data[i]);
            }
          }
        }
      }

      if (stickyArr.length) {
        if (this.props.isUserPrime) {
          // Todo:  | This is removing other widgets | need to be refactor
          stickyArr = stickyArr.filter(
            item =>
              item.tn === 'times_assist' ||
              item.tn === 'affiliates_widget_rhs' ||
              this.props.isUserPrime,
          );
        }
        return this.getWidgetsMap(stickyArr);
      }
      return null;
    }
    return null;
  }

  getReviewsWidgets = () => {
    const { data } = this.props.data;
    const widgetsMap = [];

    if (data instanceof Array) {
      data.forEach(item => {
        const { tn = '' } = item || {};
        if (tn === 'affiliate_rhs_widget') {
          widgetsMap.push(this.props.ReviewsAffiliateRHSWidget);
        }
      });
    }
    return widgetsMap;
  };

  render() {
    const {
      stickySideBarClasses,
      isStickyHeaderVisible,
      isFeatureshow,
    } = this.props;
    let stickyBehaviorClass;
    if (stickySideBarClasses) {
      stickyBehaviorClass = classNames({
        [`${stickySideBarClasses.sticky}`]: isStickyHeaderVisible,
        [`${stickySideBarClasses.stickyWithoutHeader}`]: !isStickyHeaderVisible,
      });
    }
    if (
      this.props.data &&
      this.props.data.data instanceof Array &&
      this.props.data.data.length > 0
    ) {
      const { theme } = this.props.data;
      if (this.props.isRHSWidgetAS && this.props.isUserPrime) {
        return (
          <div
            className={`${this.props.stickyCss} ${stickyBehaviorClass} ${
              s.stickyWrapper
            }`}
          >
            {this.props.isReviewsPage && this.getReviewsWidgets()}
            {this.getAllWidgets()}
            {this.getStickyWidgets()}
          </div>
        );
      }
      return (
        <>
          <div
            data-mod="sidebar"
            data-sidebartheme={theme}
            className={`${s.sidebar_container} sidebar_ad_fix ${
              isFeatureshow ? s.featureshow_sidebar : ''
            }`}
          >
            {this.props.isReviewsPage && this.getReviewsWidgets()}
            {this.getAllWidgets()}
          </div>

          {!isFeatureshow && (
            <div
              className={`${this.props.stickyCss} ${stickyBehaviorClass} ${
                s.stickyWrapper
              }`}
            >
              {this.getStickyWidgets()}
            </div>
          )}
        </>
      );
    }
    return <div className={s.sidebar_container} />;
  }
}

const mapStateToProps = state => ({
  currentCountry:
    state.geo && state.geo.currentCountry ? state.geo.currentCountry : '',
  showToiPlusEntryPoints: _get(
    state,
    'toiplusconfig.showToiPlusEntryPoints',
    false,
  ),
  isSaleLive:
    _get(
      state,
      'common.siteConfig.affiliates.saleStatus.isIndiaSaleLive',
      'false',
    ) === 'true',
  isStickyHeaderVisible: _get(state, 'commonData.isStickyHeaderVisible', false),
  isReviewsPage: state.isTOIReviews,
});

Sidebar.propTypes = {
  data: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    data: PropTypes.array.isRequired,
    theme: PropTypes.string.isRequired,
    onlyAdSticky: PropTypes.bool,
  }).isRequired,
  msid: PropTypes.string,
  showToiPlusEntryPoints: PropTypes.bool,
  breadCrumbString: PropTypes.string,
  //applyStickyClass: PropTypes.bool,
  currentCountry: PropTypes.string,
  params: PropTypes.shape({}),
  openVideosInTheatre: PropTypes.bool,
  gaPrefix: PropTypes.string,
  sidebarMapping: PropTypes.shape({}).isRequired,
  ads: PropTypes.shape({}),
  widgetCss: PropTypes.shape({}),
  morlinkOpenInNewTab: PropTypes.string,
  props: PropTypes.shape({}),
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  secName: PropTypes.string,
  isUserPrime: PropTypes.bool,
  firstNonAdWidget: PropTypes.shape({}),
  AffiliateRHSWidget: PropTypes.element,
  ReviewsAffiliateRHSWidget: PropTypes.element,
  //AstroTalkRHSWidget: PropTypes.element,
  rhsWidgetPriority: PropTypes.shape({}),
  isMspArticle: PropTypes.bool,
  isAdRemoved: PropTypes.bool,
  isRHSWidgetAS: PropTypes.bool,
  isRHSWidgetPS: PropTypes.bool,
  isSaleLive: PropTypes.bool,
  isStickyHeaderVisible: PropTypes.bool,
  stickySideBarClasses: PropTypes.shape({
    sticky: PropTypes.string,
    stickyWithoutHeader: PropTypes.string,
  }),
  spotlightSpecificAds: PropTypes.bool,
  isFeatureshow: PropTypes.bool,
  isReviewsPage: PropTypes.bool,
};

Sidebar.defaultProps = {
  msid: '',
  breadCrumbString: '',
  gaPrefix: 'RHS',
  //applyStickyClass: true,
  currentCountry: '',
  params: {},
  openVideosInTheatre: false,
  ads: undefined,
  widgetCss: undefined,
  morlinkOpenInNewTab: '',
  props: {},
  gaCategory: '',
  gaAction: '',
  showToiPlusEntryPoints: false,
  secName: '',
  isUserPrime: false,
  firstNonAdWidget: {},
  AffiliateRHSWidget: null,
  ReviewsAffiliateRHSWidget: null,
  //AstroTalkRHSWidget: null,
  rhsWidgetPriority: undefined,
  isMspArticle: false,
  isRHSWidgetAS: false,
  isRHSWidgetPS: false,
  isAdRemoved: false,
  isSaleLive: false,
  isStickyHeaderVisible: false,
  stickySideBarClasses: null,
  spotlightSpecificAds: false,
  isFeatureshow: false,
  isReviewsPage: false,
};

export default connect(mapStateToProps)(Sidebar);
